<template>
  <div class="account_w site_min_w">
    <div class="content_w bc_FAFAFA">
      <div class="site_content d_flex justify_content_sb">
        <div class="account_menu_w bc_fff">
          <!-- 我的账户 -->
          <div>
            <div
              class="directory_i"
              :class="accountsetStyle ? 'bc_0983CC c_fff' : 'bc_e6e6e6'"
            >
              <img
                :src="
                  require(`@/assets/images/${
                    accountsetStyle ? 'account_1' : 'account_6'
                  }.png`)
                "
                alt=""
              />
              <span class="span_1">我的账户</span>
            </div>
            <router-link to="/account/setting">
              <div
                class="menu_i c333 fz16"
                :class="accountsetStyle ? 'c_2CAEFF' : ''"
              >
                <img :src="
                  require(`@/assets/images/${
                    accountsetStyle ? 'account_2' : 'account_7'
                  }.png`)" alt="">
                <span class="span_2">账户设置</span>
              </div>
            </router-link>
          </div>

          <!-- 交易管理 -->
          <div>
            <div
              class="directory_i"
              :class="signupStyle || auctionStyle ? 'bc_0983CC c_fff' : 'bc_e6e6e6'"
            >
              <img
                :src="
                  require(`@/assets/images/${
                    signupStyle || auctionStyle ? 'account_8' : 'account_3'
                  }.png`)
                "
                alt=""
              />
              <span class="span_1">交易管理</span>
            </div>
            <router-link to="/account/apply"
              >
              <div
                class="menu_i c333 fz16"
                :class="signupStyle ? 'c_2CAEFF' : ''"
              >
                <img :src="
                  require(`@/assets/images/${
                    signupStyle  ? 'account_9' : 'account_4'
                  }.png`)" alt="">
                <span class="span_2">我的报名</span>
              </div>
              </router-link
            >
            <router-link to="/account/auction"
              >
              <div
                class="menu_i c333 fz16"
                :class="auctionStyle ? 'c_2CAEFF' : ''"
              >
                <img :src="
                  require(`@/assets/images/${
                    auctionStyle  ? 'account_10' : 'account_5'
                  }.png`)" alt="">
                <span class="span_2">我的竞拍</span>
              </div>
              </router-link
            >
          </div>

          <!-- 消息中心 -->
          <div>
            <div
              class="directory_i"
              :class="msgStyle ? 'bc_0983CC c_fff' : 'bc_e6e6e6'"
            >
              <img
                :src="
                  require(`@/assets/images/${
                    msgStyle ? 'account_1' : 'account_6'
                  }.png`)
                "
                alt=""
              />
              <span class="span_1">消息中心</span>
            </div>
            <router-link to="/account/msg">
              <div
                class="menu_i c333 fz16"
                :class="msgStyle ? 'c_2CAEFF' : ''"
              >
                <img :src="
                  require(`@/assets/images/${
                    msgStyle ? 'account_2' : 'account_7'
                  }.png`)" alt="">
                <span class="span_2">消息通知</span>
              </div>
            </router-link>
          </div>
        </div>

        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {
  },
  computed: {
    accountsetStyle() {
      for (let v of ["setting", "modifypsw", "findpsw", "replacephone"]) {
        if (this.$route.path.indexOf(v) !== -1) {
          return true;
        }
      }
      return false;
    },
    // 竞拍
    auctionStyle() {
      return this.$route.path === "/account/auction";
    },
    // 报名
    signupStyle() {
      return this.$route.path === "/account/apply";
    },
    // 消息
    msgStyle() {
      return this.$route.path === "/account/msg";
    },
  },
};
</script>

<style lang="scss" scoped>
.account_w {
  margin: 20px 0;
  .content_w {
    margin: 0 auto;
  }
  .account_menu_w {
    width: 216px;
    height: fit-content;
    border: 1px solid #dbdbdb;
    .directory_i {
      display: flex;
      align-items: center;
      padding: 15px 20px;
    }
    .menu_i {
      display: flex;
      align-items: flex-start;
      padding: 17px 55px;
      cursor: pointer;
    }
  }
  .span_1 {
    margin: 0 0 0 8px;
  }
  .span_2{
    margin: 0 0 0 10px;
  }
}
</style>